"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _commonRichText = require("@mmc/common-rich-text");

var _commonI18n = require("@mmc/common-i18n");

var _reactRedux = require("react-redux");

var _configuratorSmallSummary = _interopRequireDefault(require("../styles/configurator-small-summary.css"));

var _shareLink = _interopRequireDefault(require("./share-link"));

var _configuratorSmallSummary2 = _interopRequireDefault(require("./configurator-small-summary.props/configurator-small-summary.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DEFAULT_PROPS = {};
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var renderPreferenceItem = function renderPreferenceItem(item, i) {
  if (item) {
    if (item.code) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: handleNestedProp(item, 'item.id') + "-" + i
      }, handleNestedProp(item, 'item.label'));
    }

    return [];
  }

  return [];
};

var ConfigurationTextBlock = function ConfigurationTextBlock(_ref) {
  var data = _ref.data,
      changeModel = _ref.changeModel,
      config = _ref.config,
      rootUrl = _ref.rootUrl,
      direction = _ref.direction,
      theme = _ref.theme,
      hidePrice = _ref.hidePrice,
      hideChange = _ref.hideChange;
  var preferences = [data.fuelType, data.driveType, data.transmissionType];
  var descriptionIsMissing = handleNestedProp(data, 'data.model.description') === ' ' || handleNestedProp(data, 'data.model.description') === null || handleNestedProp(data, 'data.model.description') === '';
  var totalPriceValue = handleNestedProp(data, 'data.totalPrice.value');
  var zeroMessage = handleNestedProp(data, 'data.model.price.zeroMessage');
  var modelPriceValue = handleNestedProp(data, 'data.model.price.value');
  var hasZeroMessage = typeof zeroMessage === 'string' && zeroMessage.length > 1;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-4'] + " " + _configuratorSmallSummary["default"].info,
    dir: direction
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: theme.labelMedium + " " + theme.marginBottom20
  }, handleNestedProp(data, 'data.configurationTitle')), /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorSmallSummary["default"].content
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorSmallSummary["default"].header
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: theme.headingTwo + " " + _configuratorSmallSummary["default"].name + " " + theme.marginBottom5
  }, handleNestedProp(data, 'data.vehicle.name'), ' ', handleNestedProp(data, 'data.model.name')), !hidePrice && data.totalPrice !== ' ' && data.totalPrice !== null && (totalPriceValue > 0 || hasZeroMessage) && /*#__PURE__*/_react["default"].createElement("h4", {
    className: _configuratorSmallSummary["default"].price + " " + theme.marginBottom40
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: modelPriceValue === 0 ? modelPriceValue : totalPriceValue,
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode'),
      zeroMessage: zeroMessage
    }
  }))), !descriptionIsMissing ? /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.bodyCopy + " " + theme.marginBottom20 + " " + _configuratorSmallSummary["default"].richTextHeadlines
  }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
    theme: theme,
    format: null,
    html: handleNestedProp(data, 'data.model.description')
  })) : '', /*#__PURE__*/_react["default"].createElement("ul", {
    className: theme.row + " " + theme.inputsAndOptions + " " + _configuratorSmallSummary["default"].preferences
  }, preferences.map(function (item, i) {
    return renderPreferenceItem(item, i);
  }))), rootUrl && data.configuratorCode && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
    className: theme.bodyCopy + " " + _configuratorSmallSummary["default"].shareDescription
  }, data.shareDescription), /*#__PURE__*/_react["default"].createElement(_shareLink["default"], {
    rootUrl: rootUrl,
    configuratorCode: data.configuratorCode,
    copyText: data.copyText,
    theme: theme
  })), !hideChange && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    data: {
      priority: 'low',
      label: data.changeText
    },
    classes: [_configuratorSmallSummary["default"].editBtn],
    theme: theme,
    clickEvent: changeModel
  }));
};

ConfigurationTextBlock.displayName = 'ConfigurationTextBlock';
ConfigurationTextBlock.defaultProps = {
  data: DEFAULT_PROPS,
  theme: {},
  config: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ConfigurationTextBlock);

exports["default"] = _default;